/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface DmsSubsidiesDocumentDto
 */
export interface DmsSubsidiesDocumentDto {
    /**
     * 
     * @type {number}
     * @memberof DmsSubsidiesDocumentDto
     */
    documentId: number;
    /**
     * 
     * @type {number}
     * @memberof DmsSubsidiesDocumentDto
     */
    dossierId: number;
    /**
     * 
     * @type {DocumentSoort}
     * @memberof DmsSubsidiesDocumentDto
     */
    documentsoort?: DocumentSoort;
    /**
     * 
     * @type {string}
     * @memberof DmsSubsidiesDocumentDto
     */
    documentdatum: string;
    /**
     * 
     * @type {string}
     * @memberof DmsSubsidiesDocumentDto
     */
    uploadedDate: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DocumentSoort {
    PreAdviesFormulier = 'PreAdviesFormulier',
    ToestemmingsVerklaring = 'ToestemmingsVerklaring',
    Weekbestand = 'Weekbestand'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ExterneGebruikerLoginError {
    OrganisationUnknown = 'OrganisationUnknown',
    ContactInformationNeeded = 'ContactInformationNeeded',
    IntermediationNotSupported = 'IntermediationNotSupported',
    CrmAndUserOrganisationMismatch = 'CrmAndUserOrganisationMismatch',
    UserManagementNotAllowed = 'UserManagementNotAllowed'
}

/**
 * 
 * @export
 * @interface FormulierDto
 */
export interface FormulierDto {
    /**
     * 
     * @type {boolean}
     * @memberof FormulierDto
     */
    hasBackendErrors: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormulierDto
     */
    responseMessages?: Array<string>;
    /**
     * 
     * @type {GegevensWerknemerDto}
     * @memberof FormulierDto
     */
    gegevensWerknemer: GegevensWerknemerDto;
    /**
     * 
     * @type {GegevensWerkgeverDto}
     * @memberof FormulierDto
     */
    gegevensWerkgever: GegevensWerkgeverDto;
    /**
     * 
     * @type {GegevensUitvoerderPreAdviesDto}
     * @memberof FormulierDto
     */
    gegevensUitvoerderPreAdvies: GegevensUitvoerderPreAdviesDto;
    /**
     * 
     * @type {ResultaatPreAdviesDto}
     * @memberof FormulierDto
     */
    resultaatPreAdvies: ResultaatPreAdviesDto;
}
/**
 * 
 * @export
 * @interface FormulierDtoAllOf
 */
export interface FormulierDtoAllOf {
    /**
     * 
     * @type {GegevensWerknemerDto}
     * @memberof FormulierDtoAllOf
     */
    gegevensWerknemer: GegevensWerknemerDto;
    /**
     * 
     * @type {GegevensWerkgeverDto}
     * @memberof FormulierDtoAllOf
     */
    gegevensWerkgever: GegevensWerkgeverDto;
    /**
     * 
     * @type {GegevensUitvoerderPreAdviesDto}
     * @memberof FormulierDtoAllOf
     */
    gegevensUitvoerderPreAdvies: GegevensUitvoerderPreAdviesDto;
    /**
     * 
     * @type {ResultaatPreAdviesDto}
     * @memberof FormulierDtoAllOf
     */
    resultaatPreAdvies: ResultaatPreAdviesDto;
}
/**
 * 
 * @export
 * @interface GegevensUitvoerderPreAdviesDto
 */
export interface GegevensUitvoerderPreAdviesDto {
    /**
     * 
     * @type {boolean}
     * @memberof GegevensUitvoerderPreAdviesDto
     */
    hasBackendErrors: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GegevensUitvoerderPreAdviesDto
     */
    responseMessages?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDto
     */
    naamOrganisatie: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDto
     */
    voorletters: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDto
     */
    tussenvoegsel?: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDto
     */
    achternaam: string;
    /**
     * 
     * @type {Geslacht}
     * @memberof GegevensUitvoerderPreAdviesDto
     */
    geslacht: Geslacht;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDto
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDto
     */
    huisnummer: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDto
     */
    huisnummerToevoeging?: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDto
     */
    adres: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDto
     */
    plaats: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDto
     */
    telefoonnummer: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDto
     */
    eMailAdres: string;
}
/**
 * 
 * @export
 * @interface GegevensUitvoerderPreAdviesDtoAllOf
 */
export interface GegevensUitvoerderPreAdviesDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDtoAllOf
     */
    naamOrganisatie: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDtoAllOf
     */
    voorletters: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDtoAllOf
     */
    tussenvoegsel?: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDtoAllOf
     */
    achternaam: string;
    /**
     * 
     * @type {Geslacht}
     * @memberof GegevensUitvoerderPreAdviesDtoAllOf
     */
    geslacht: Geslacht;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDtoAllOf
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDtoAllOf
     */
    huisnummer: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDtoAllOf
     */
    huisnummerToevoeging?: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDtoAllOf
     */
    adres: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDtoAllOf
     */
    plaats: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDtoAllOf
     */
    telefoonnummer: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensUitvoerderPreAdviesDtoAllOf
     */
    eMailAdres: string;
}
/**
 * 
 * @export
 * @interface GegevensWerkgeverDto
 */
export interface GegevensWerkgeverDto {
    /**
     * 
     * @type {boolean}
     * @memberof GegevensWerkgeverDto
     */
    hasBackendErrors: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GegevensWerkgeverDto
     */
    responseMessages?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerkgeverDto
     */
    naamOrganisatie: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerkgeverDto
     */
    voorletters: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerkgeverDto
     */
    tussenvoegsel?: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerkgeverDto
     */
    achternaam: string;
    /**
     * 
     * @type {Geslacht}
     * @memberof GegevensWerkgeverDto
     */
    geslacht: Geslacht;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerkgeverDto
     */
    telefoonnummer: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerkgeverDto
     */
    eMailAdres: string;
}
/**
 * 
 * @export
 * @interface GegevensWerkgeverDtoAllOf
 */
export interface GegevensWerkgeverDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof GegevensWerkgeverDtoAllOf
     */
    naamOrganisatie: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerkgeverDtoAllOf
     */
    voorletters: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerkgeverDtoAllOf
     */
    tussenvoegsel?: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerkgeverDtoAllOf
     */
    achternaam: string;
    /**
     * 
     * @type {Geslacht}
     * @memberof GegevensWerkgeverDtoAllOf
     */
    geslacht: Geslacht;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerkgeverDtoAllOf
     */
    telefoonnummer: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerkgeverDtoAllOf
     */
    eMailAdres: string;
}
/**
 * 
 * @export
 * @interface GegevensWerknemerDto
 */
export interface GegevensWerknemerDto {
    /**
     * 
     * @type {boolean}
     * @memberof GegevensWerknemerDto
     */
    hasBackendErrors: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GegevensWerknemerDto
     */
    responseMessages?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDto
     */
    voorletters: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDto
     */
    tussenvoegsel?: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDto
     */
    achternaam: string;
    /**
     * 
     * @type {Geslacht}
     * @memberof GegevensWerknemerDto
     */
    geslacht: Geslacht;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDto
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDto
     */
    huisnummer: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDto
     */
    huisnummerToevoeging?: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDto
     */
    adres: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDto
     */
    plaats: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDto
     */
    geboorteDatum: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDto
     */
    datumEersteZiekteDag: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDto
     */
    datumPreAdvies: string;
}
/**
 * 
 * @export
 * @interface GegevensWerknemerDtoAllOf
 */
export interface GegevensWerknemerDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDtoAllOf
     */
    voorletters: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDtoAllOf
     */
    tussenvoegsel?: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDtoAllOf
     */
    achternaam: string;
    /**
     * 
     * @type {Geslacht}
     * @memberof GegevensWerknemerDtoAllOf
     */
    geslacht: Geslacht;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDtoAllOf
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDtoAllOf
     */
    huisnummer: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDtoAllOf
     */
    huisnummerToevoeging?: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDtoAllOf
     */
    adres: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDtoAllOf
     */
    plaats: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDtoAllOf
     */
    geboorteDatum: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDtoAllOf
     */
    datumEersteZiekteDag: string;
    /**
     * 
     * @type {string}
     * @memberof GegevensWerknemerDtoAllOf
     */
    datumPreAdvies: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum Geslacht {
    Man = 'Man',
    Vrouw = 'Vrouw',
    Anders = 'Anders'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum OptiesExcl {
    Ja = 'Ja',
    Nee = 'Nee'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum OptiesIncl {
    SmallerThan35 = 'SmallerThan35',
    Between35And80 = 'Between35And80',
    GreaterThan80 = 'GreaterThan80',
    NietVanToepassing = 'NietVanToepassing'
}

/**
 * 
 * @export
 * @interface PairedDocumentDto
 */
export interface PairedDocumentDto {
    /**
     * 
     * @type {DmsSubsidiesDocumentDto}
     * @memberof PairedDocumentDto
     */
    preadviesFormulier?: DmsSubsidiesDocumentDto;
    /**
     * 
     * @type {DmsSubsidiesDocumentDto}
     * @memberof PairedDocumentDto
     */
    toestemmingverklaringFile?: DmsSubsidiesDocumentDto;
    /**
     * 
     * @type {string}
     * @memberof PairedDocumentDto
     */
    preadviesFileName?: string;
    /**
     * 
     * @type {string}
     * @memberof PairedDocumentDto
     */
    toestemmingsverklaringFileName?: string;
}
/**
 * 
 * @export
 * @interface ResponseBase
 */
export interface ResponseBase {
    /**
     * 
     * @type {boolean}
     * @memberof ResponseBase
     */
    hasBackendErrors: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponseBase
     */
    responseMessages?: Array<string>;
}
/**
 * 
 * @export
 * @interface ResultaatPreAdviesDto
 */
export interface ResultaatPreAdviesDto {
    /**
     * 
     * @type {boolean}
     * @memberof ResultaatPreAdviesDto
     */
    hasBackendErrors: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultaatPreAdviesDto
     */
    responseMessages?: Array<string>;
    /**
     * 
     * @type {OptiesExcl}
     * @memberof ResultaatPreAdviesDto
     */
    vraag1: OptiesExcl;
    /**
     * 
     * @type {OptiesIncl}
     * @memberof ResultaatPreAdviesDto
     */
    vraag2: OptiesIncl;
    /**
     * 
     * @type {OptiesExcl}
     * @memberof ResultaatPreAdviesDto
     */
    vraag3: OptiesExcl;
    /**
     * 
     * @type {string}
     * @memberof ResultaatPreAdviesDto
     */
    vraag4: string;
    /**
     * 
     * @type {string}
     * @memberof ResultaatPreAdviesDto
     */
    vraag5: string;
    /**
     * 
     * @type {string}
     * @memberof ResultaatPreAdviesDto
     */
    vraag6: string;
    /**
     * 
     * @type {string}
     * @memberof ResultaatPreAdviesDto
     */
    vraag7: string;
}
/**
 * 
 * @export
 * @interface ResultaatPreAdviesDtoAllOf
 */
export interface ResultaatPreAdviesDtoAllOf {
    /**
     * 
     * @type {OptiesExcl}
     * @memberof ResultaatPreAdviesDtoAllOf
     */
    vraag1: OptiesExcl;
    /**
     * 
     * @type {OptiesIncl}
     * @memberof ResultaatPreAdviesDtoAllOf
     */
    vraag2: OptiesIncl;
    /**
     * 
     * @type {OptiesExcl}
     * @memberof ResultaatPreAdviesDtoAllOf
     */
    vraag3: OptiesExcl;
    /**
     * 
     * @type {string}
     * @memberof ResultaatPreAdviesDtoAllOf
     */
    vraag4: string;
    /**
     * 
     * @type {string}
     * @memberof ResultaatPreAdviesDtoAllOf
     */
    vraag5: string;
    /**
     * 
     * @type {string}
     * @memberof ResultaatPreAdviesDtoAllOf
     */
    vraag6: string;
    /**
     * 
     * @type {string}
     * @memberof ResultaatPreAdviesDtoAllOf
     */
    vraag7: string;
}
/**
 * 
 * @export
 * @interface SignOutDto
 */
export interface SignOutDto {
    /**
     * 
     * @type {boolean}
     * @memberof SignOutDto
     */
    redirectToEherkenningSSO: boolean;
}
/**
 * 
 * @export
 * @interface UserInfoDto
 */
export interface UserInfoDto {
    /**
     * 
     * @type {string}
     * @memberof UserInfoDto
     */
    eherkenningPseudo?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoDto
     */
    organisatienaam?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoDto
     */
    kvKnummer?: string;
}

/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GegevensWerknemerDto} gegevensWerknemer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentAddToCsv: async (gegevensWerknemer: GegevensWerknemerDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gegevensWerknemer' is not null or undefined
            if (gegevensWerknemer === null || gegevensWerknemer === undefined) {
                throw new RequiredError('gegevensWerknemer','Required parameter gegevensWerknemer was null or undefined when calling documentAddToCsv.');
            }
            const localVarPath = `/api/Document/weekbestand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof gegevensWerknemer !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(gegevensWerknemer !== undefined ? gegevensWerknemer : {}) : (gegevensWerknemer || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} documentId 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentDownloadDocumentById: async (documentId: number, filename?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new RequiredError('documentId','Required parameter documentId was null or undefined when calling documentDownloadDocumentById.');
            }
            const localVarPath = `/api/Document/downloadDocument/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetAllUserDocuments: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/getAllUserDocuments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FormulierDto} formulier 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentUploadPreadviesFormulier: async (formulier: FormulierDto, filename?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'formulier' is not null or undefined
            if (formulier === null || formulier === undefined) {
                throw new RequiredError('formulier','Required parameter formulier was null or undefined when calling documentUploadPreadviesFormulier.');
            }
            const localVarPath = `/api/Document/uploadPreadviesFormulier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof formulier !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(formulier !== undefined ? formulier : {}) : (formulier || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filename] 
         * @param {number} [dossierId] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentUploadToestemmingverklaringFile: async (filename?: string, dossierId?: number, file?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/uploadToestemmingverklaring`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


            if (dossierId !== undefined) { 
                localVarFormParams.append('dossierId', dossierId as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GegevensWerknemerDto} gegevensWerknemer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentAddToCsv(gegevensWerknemer: GegevensWerknemerDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await DocumentApiAxiosParamCreator(configuration).documentAddToCsv(gegevensWerknemer, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} documentId 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentDownloadDocumentById(documentId: number, filename?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await DocumentApiAxiosParamCreator(configuration).documentDownloadDocumentById(documentId, filename, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentGetAllUserDocuments(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PairedDocumentDto>>> {
            const localVarAxiosArgs = await DocumentApiAxiosParamCreator(configuration).documentGetAllUserDocuments(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {FormulierDto} formulier 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentUploadPreadviesFormulier(formulier: FormulierDto, filename?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await DocumentApiAxiosParamCreator(configuration).documentUploadPreadviesFormulier(formulier, filename, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [filename] 
         * @param {number} [dossierId] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentUploadToestemmingverklaringFile(filename?: string, dossierId?: number, file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await DocumentApiAxiosParamCreator(configuration).documentUploadToestemmingverklaringFile(filename, dossierId, file, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {GegevensWerknemerDto} gegevensWerknemer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentAddToCsv(gegevensWerknemer: GegevensWerknemerDto, options?: any): AxiosPromise<boolean> {
            return DocumentApiFp(configuration).documentAddToCsv(gegevensWerknemer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} documentId 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentDownloadDocumentById(documentId: number, filename?: string, options?: any): AxiosPromise<any> {
            return DocumentApiFp(configuration).documentDownloadDocumentById(documentId, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetAllUserDocuments(options?: any): AxiosPromise<Array<PairedDocumentDto>> {
            return DocumentApiFp(configuration).documentGetAllUserDocuments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FormulierDto} formulier 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentUploadPreadviesFormulier(formulier: FormulierDto, filename?: string, options?: any): AxiosPromise<number> {
            return DocumentApiFp(configuration).documentUploadPreadviesFormulier(formulier, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filename] 
         * @param {number} [dossierId] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentUploadToestemmingverklaringFile(filename?: string, dossierId?: number, file?: any, options?: any): AxiosPromise<boolean> {
            return DocumentApiFp(configuration).documentUploadToestemmingverklaringFile(filename, dossierId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     * 
     * @param {GegevensWerknemerDto} gegevensWerknemer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentAddToCsv(gegevensWerknemer: GegevensWerknemerDto, options?: any) {
        return DocumentApiFp(this.configuration).documentAddToCsv(gegevensWerknemer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} documentId 
     * @param {string} [filename] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentDownloadDocumentById(documentId: number, filename?: string, options?: any) {
        return DocumentApiFp(this.configuration).documentDownloadDocumentById(documentId, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentGetAllUserDocuments(options?: any) {
        return DocumentApiFp(this.configuration).documentGetAllUserDocuments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FormulierDto} formulier 
     * @param {string} [filename] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentUploadPreadviesFormulier(formulier: FormulierDto, filename?: string, options?: any) {
        return DocumentApiFp(this.configuration).documentUploadPreadviesFormulier(formulier, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filename] 
     * @param {number} [dossierId] 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentUploadToestemmingverklaringFile(filename?: string, dossierId?: number, file?: any, options?: any) {
        return DocumentApiFp(this.configuration).documentUploadToestemmingverklaringFile(filename, dossierId, file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ExternalLoginApi - axios parameter creator
 * @export
 */
export const ExternalLoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalLoginEherkenning: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/ExternalLogin/eherkenning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalLoginEherkenningSignout: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/ExternalLogin/eherkenning/signout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalLoginApi - functional programming interface
 * @export
 */
export const ExternalLoginApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalLoginEherkenning(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await ExternalLoginApiAxiosParamCreator(configuration).externalLoginEherkenning(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalLoginEherkenningSignout(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await ExternalLoginApiAxiosParamCreator(configuration).externalLoginEherkenningSignout(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExternalLoginApi - factory interface
 * @export
 */
export const ExternalLoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalLoginEherkenning(options?: any): AxiosPromise<any> {
            return ExternalLoginApiFp(configuration).externalLoginEherkenning(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalLoginEherkenningSignout(options?: any): AxiosPromise<any> {
            return ExternalLoginApiFp(configuration).externalLoginEherkenningSignout(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalLoginApi - object-oriented interface
 * @export
 * @class ExternalLoginApi
 * @extends {BaseAPI}
 */
export class ExternalLoginApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalLoginApi
     */
    public externalLoginEherkenning(options?: any) {
        return ExternalLoginApiFp(this.configuration).externalLoginEherkenning(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalLoginApi
     */
    public externalLoginEherkenningSignout(options?: any) {
        return ExternalLoginApiFp(this.configuration).externalLoginEherkenningSignout(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoginApi - axios parameter creator
 * @export
 */
export const LoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAuthenticateEherkenningUser: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Login/eherkenning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginLogoutUser: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginApi - functional programming interface
 * @export
 */
export const LoginApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAuthenticateEherkenningUser(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await LoginApiAxiosParamCreator(configuration).loginAuthenticateEherkenningUser(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginLogoutUser(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignOutDto>> {
            const localVarAxiosArgs = await LoginApiAxiosParamCreator(configuration).loginLogoutUser(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoginApi - factory interface
 * @export
 */
export const LoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAuthenticateEherkenningUser(options?: any): AxiosPromise<void> {
            return LoginApiFp(configuration).loginAuthenticateEherkenningUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginLogoutUser(options?: any): AxiosPromise<SignOutDto> {
            return LoginApiFp(configuration).loginLogoutUser(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
export class LoginApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public loginAuthenticateEherkenningUser(options?: any) {
        return LoginApiFp(this.configuration).loginAuthenticateEherkenningUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public loginLogoutUser(options?: any) {
        return LoginApiFp(this.configuration).loginLogoutUser(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUser: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGetUser(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfoDto>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).userGetUser(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUser(options?: any): AxiosPromise<UserInfoDto> {
            return UserApiFp(configuration).userGetUser(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userGetUser(options?: any) {
        return UserApiFp(this.configuration).userGetUser(options).then((request) => request(this.axios, this.basePath));
    }
}


